<template>
    <div class="modal">
        <div class="modal__top">
            <span class="modal__close ml-auto mb-3" @click="$emit('close')">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M178.3 178.3C181.5 175.2 186.5 175.2 189.7 178.3L256 244.7L322.3 178.3C325.5 175.2 330.5 175.2 333.7 178.3C336.8 181.5 336.8 186.5 333.7 189.7L267.3 256L333.7 322.3C336.8 325.5 336.8 330.5 333.7 333.7C330.5 336.8 325.5 336.8 322.3 333.7L256 267.3L189.7 333.7C186.5 336.8 181.5 336.8 178.3 333.7C175.2 330.5 175.2 325.5 178.3 322.3L244.7 256L178.3 189.7C175.2 186.5 175.2 181.5 178.3 178.3V178.3zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 16C123.5 16 16 123.5 16 256C16 388.5 123.5 496 256 496C388.5 496 496 388.5 496 256C496 123.5 388.5 16 256 16z"/></svg>
            </span>
        </div>
        <div class="modal__box">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2 class="title title--2 color-pink mb-3">Summary</h2>
                        <div class="summary">
                            <div v-for="(section,index) of formSummary" :key="index" class="summary-section">
                                <h3 class="title title--3 color-pink mb-1-5">{{ section.title }}</h3>
                                <ul class="summary-list">
                                    <li v-for="(field,index) of section.fields" :key="index" class="summary-list__item">
                                        <span v-if="typeof field === 'string'"><strong>{{ index }}</strong>: {{ field }}</span>
                                        <span v-else-if="field && Array.isArray(field) && typeof field[0] === 'string'">
                                            <strong>{{ index }}</strong>:<br>
                                            <span v-for="field of field" :key="field" class="summary__inline">{{ field }}</span>
                                        </span>
                                        <span v-else-if="field && Object.entries(field[0]).length">
                                            <strong>{{ index }}</strong>:
                                            <span v-for="(object,index) of field" :key="index">
                                                <ul class="summary__block">
                                                    <li v-for="(field,index) of object" :key="index">
                                                        <strong>{{ index }}</strong>: {{ field }}
                                                    </li>
                                                </ul>
                                            </span>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                            <div v-if="pricing" class="summary-section">
                                <h3 class="title title--3 color-pink mb-1-5">Your Price(s)</h3>
                                <ul class="summary-list">
                                    <li v-for="(value,index) of pricing" :key="`price-${index}`">
                                        <strong>{{ index }}</strong>: {{ value | currency }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="button-list">
                            <a href="#" @click.prevent="$emit('close')" class="button">Close</a>
                            <a href="#" @click.prevent="emitSubmit" class="button">Confirm</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { EventBus } from '../../_vue-event-bus';

export default {
    props: {
        formData: {
            type: Object,
            required: true
        },
        formLabels: {
            type: Object,
            required: true
        },
        pricing: {
            type: Object
        }
    },
    computed: {
        ...mapGetters(['formSummary']),
    },
    methods: {
        emitSubmit() {
            EventBus.$emit('submit-details');
            this.$emit('close');
        }
    }
}
</script>